import React, { Component } from 'react';
import './App.css';
import 'firebase/database';
import { Route, withRouter } from 'react-router-dom';

import './firebase';

import home from './views/home/home';
import Login from './views/login/login';
import Dash from './views/dashboard/dashboard';
import Para from './views/parametrizacion/parametrizacion';
import firebase from 'firebase'

import {connect} from 'react-redux'

class App extends Component {
  
  constructor(){
    super();
    this.state = {
      isFirstRender:true,
      url: window.location.pathname
    }
    this.validarSesiones();
    // firebase.auth().signOut().then(function() {
    //   localStorage.removeItem('user');
    // }).catch(function(error) {
    //   console.log('No se puede cerrar sesión' + error);
    // });
  }

  validarSesiones = () => {
    //agente de escucha cuando se hace un login o un logout
    firebase.auth().onAuthStateChanged(user=>{
      this.props.setUser(user); //seteo el usuario logeado al store 

      if(user){ // verifico que esta logeado
        localStorage.setItem('user', true); //lo creo en el localstorage
        // console.log(this.state.url);
        if(this.state.url === '/admin' || this.state.url === '/'){ //si intenta volver al admin 
          this.props.history.push('/admin/dashboard/Estadisticas');  // lo retorno a la pagina donde estaba
          // console.log('estoy logeado');
        }
      }else {
        localStorage.removeItem('user'); //si no esta logeado borro el item del local storage
        if(this.state.url !== '/'){
          this.props.history.push('/admin'); //regresa al login si no hay usuario en logeado
        } 
      }

      if(this.state.isFirstRender){
        this.setState({isFirstRender:false})
      }else{
        if(user){
          this.props.history.push('/admin/dashboard/Estadisticas'); //esta es la ruta para cuando inicia sesion
          // this.props.history.push('/admin/parametrizacion/Chatbot');
        }
      }
    })
  }

  render() {
    return(
      <div>
        <Route exact path="/" component={home}/>
        <Route exact path="/admin" component={Login}/>
        <Route path="/admin/dashboard" component={Dash} />
        <Route path="/admin/parametrizacion" component={Para} />
        {/* <Route path="/logout" component={Login} /> */}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setUser:(user)=>({type:'SET_USER', payload:user})
}

export default connect(null, mapDispatchToProps)(withRouter(App));
